import {Button} from "antd";
import styled from "styled-components";

export const CustomButton = styled(Button)`
    width: auto;

    & > #status-label {
        display: block;
    }

    & > #action-label {
        display: none;
    }

    &:hover > #status-label {
        display: none;
    }

    &:hover > #action-label {
        display: block;
    }
`;
